export class DeliveryAddress {
    customerName: string;
    contactNo: number;
    pincode: number;
    cityName: string;
    stateId: number;
    districtId: number;
    address: string;
}